import React, {useState, useRef, useEffect} from 'react'
import '@/assets/css/news.scss';
import {REQUEST} from "@/api";
import intl from 'react-intl-universal';
import { useParams } from 'react-router-dom'
const News = () => {
    const [offset, setOffset] = useState(10)
    const [style1, setStyle1] = useState({})
    const [news, setNews] = useState({})

    const scrollBox = useRef()
    const params = useParams()

    const aniScroll = () => {
        const scroll = scrollBox.current
        if (scroll) {
            if (Math.abs(offset) >= scroll.scrollWidth) {
                setOffset(0)
            }
            else {
                let step = -2
                setOffset(offset => offset + step)
                setStyle1({
                    transform: `translate3d(${offset}px, 0, 0)`
                })
            }
        }
    }
    const fetchNews =() => {
        const data = {
            type: intl.getInitOptions().currentLocale === 'zh-CN' ? '1' : '2',
            mark: params.id
        }
        REQUEST('newsDetail', data).then((res) => {
            // this.data = res.body
            setNews(res.body)
        })
        // const lang = this.$i18n.locale
        // this.swiperData = SWIPER_TYPE[lang]
    }

    useEffect(() => {
        requestAnimationFrame(aniScroll)
    }, [offset])
    useEffect(() => {
        fetchNews()
    }, [])
    return (
        <div className="rl">
            <div className="rl-news rl-container">
                <div className="rl-news-id-head">
                    <div className="rl-news-id-brand flex-row-start" ref={scrollBox}>
                        <div>
                            <div className="scroll-box flex-row-start" style={style1}>
                                <p className="rl-scroll-box-text">NEWS #</p>
                                <p className="rl-scroll-box-text">NEWS #</p>
                                <p className="rl-scroll-box-text">NEWS #</p>
                                <p className="rl-scroll-box-text">NEWS #</p>
                                <p className="rl-scroll-box-text">NEWS #</p>
                            </div>
                        </div>
                    </div>
                    <div className="rl-news-banner">
                        <img src={news.image} alt=""/>
                    </div>
                </div>
                <div className="rl-news-id-content">
                    <div className="news-detail-head">
                        <div className="title">
                            {news.title}
                        </div>
                        <div className="des-info flex-between">
                            <div className="des">{news.subTitle}</div>
                            <div className="time">{news.pubTime}</div>
                        </div>
                    </div>
                    <div className="news-detail-info" dangerouslySetInnerHTML={{__html:news.content}}>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default News
